import photo from '../assets/HeadBack.webp';
import ServicePhoto from '../assets/OurServices.webp';
import PageBanner from './SectionPageBanner';

import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // You can choose any icon
import {
  Box,
  Container,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';

const services = [
  "Website Development",
  "App Development",
  "UI/UX Design",
  "E-commerce Solutions",
  "Digital Marketing",
  "Maintenance & Support",
];

const OurServices = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ bgcolor: '#fcfcfc', pb: 8 }}>
      {/* Banner */}
       <PageBanner image={photo} title="Services We Provide" />

      {/* Content */}
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 6,
            px: 2, // uniform horizontal padding
          }}
        >
          {/* Left: Service Strips */}
          <Box sx={{ flex: 1, width: '100%', paddingTop:'20px' }}>
            <Stack spacing={2}>
              {services.map((title, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    backgroundColor: '#1976d2',
                    borderRadius: 2,
                    padding: '16px 24px',
                    boxShadow: 3,
                  }}
                >
                  <CheckCircleIcon sx={{ color: 'white', fontSize: 28 }} />
                  <Typography
                    variant="h6"
                    fontWeight={600}
                    color="white"
                    fontFamily="Rajdhani"
                  >
                    {title}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </Box>

          {/* Right: Image */}
          {!isMobile && (
            <Box
              component="img"
              src={ServicePhoto}
              alt="Our Services"
              sx={{
                flex: 1,
                maxWidth: 500,
                width: '100%',
                borderRadius: 4,
                boxShadow: 4,
              }}
            />
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default OurServices;
